import ContentHistory from '../platformui/ContentHistory';
export default ContentHistory;
